import React, { useEffect } from 'react';

import { useDispatch, useSelector } from 'react-redux';
import EventsRequests from 'services/events';
import GridContainer from '@jumbo/components/GridContainer';
import { Grid } from '@material-ui/core';

import EventElement from './EventElement';

const AllEvents = () => {
  const { allEvents } = useSelector(({ events }) => events);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(EventsRequests.getAllEvents());
  }, []);

  return (
    <GridContainer>
      <Grid item xs={12}>
        {allEvents && allEvents.map(event => <EventElement data={event} key={event._id} />)}
      </Grid>
    </GridContainer>
  );
};

export default AllEvents;
